var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"h5 my-4"},[_vm._v(_vm._s(_vm.group.name))]),_vm._l((_vm.group.properties),function(property){return _c('app-property',{key:property.id,attrs:{"property":property}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }